import PackingRoutes from "./packing.js";
import HarvestExportRoutes from "./harvest_export";
import WorkLogsRoutes from "./work_logs";

export default [...PackingRoutes, ...HarvestExportRoutes, ...WorkLogsRoutes];
